<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Options</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Insurance -->
    <div class="row">
      <div class="col-md-12">
        <h5>Insurance</h5>
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th style="width: 10%">Type</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Insurance Enrolment Period</td>
                <td><enrolment-period type="Insurance"></enrolment-period></td>
              </tr>

              <tr>
                <td>Admin Instructions</td>
                <td>
                  <admin-instruction type="Insurance"></admin-instruction>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Insurance -->

    <!-- Benefit Option -->
    <div class="row mt-4">
      <div class="col-md-12">
        <h5>Benefit Option</h5>
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th style="width: 15.4%">Type</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Benefit Enrolment Period</td>
                <td><enrolment-period type="Benefit"></enrolment-period></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Benefit Option -->

    <!-- Leave of Absence -->
    <div class="row mt-4">
      <div class="col-md-12">
        <h5>Leave of Absence</h5>
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th style="width: 15.4%">Type</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Admin Instructions</td>
                <td>
                  <admin-instruction type="Leave Of Absence">
                  </admin-instruction>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Leave of Absence -->

    <!-- Leave Utilization Report -->
    <div class="row mt-4">
      <div class="col-md-12">
        <h5>Leave Utilization Report</h5>
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th style="width: 15.4%">Type</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Admin Instructions</td>
                <td>
                  <admin-instruction type="Leave Utilization Report">
                  </admin-instruction>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Leave Utilization Report -->
  </div>
</template>

<script>
import EnrolmentPeriod from "./EnrolmentPeriod.vue";
import AdminInstruction from "./AdminInstruction.vue";
export default {
  components: {
    EnrolmentPeriod,
    AdminInstruction,
  },
  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },
  created() {
    if (this.role != "admin") this.$router.replace({ name: "home" });
  },
};
</script>


// WEBPACK FOOTER //
// src/components/System/Option.vue